import { useRef } from 'react';

// Sound effects using Web Audio API
export const useSound = () => {
  const audioContextRef = useRef(null);

  const getAudioContext = () => {
    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioContextRef.current;
  };

  const resumeIfNeeded = (ctx) => {
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => { });
    }
  };

  const playCorrect = () => {
    try {
      const ctx = getAudioContext();
      resumeIfNeeded(ctx);
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);

      oscillator.frequency.setValueAtTime(880, ctx.currentTime); // A5
      oscillator.frequency.setValueAtTime(1108.73, ctx.currentTime + 0.08); // C#6

      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.15, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.15);

      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.15);
    } catch (e) {
      // Silently fail if audio not supported
    }
  };

  const playStreak = (milestone) => {
    try {
      const ctx = getAudioContext();
      resumeIfNeeded(ctx);
      const notes = milestone >= 100 ? [523.25, 659.25, 783.99, 1046.50] : // C5, E5, G5, C6
        milestone >= 50 ? [523.25, 659.25, 783.99] : // C5, E5, G5
          [523.25, 659.25]; // C5, E5

      notes.forEach((freq, i) => {
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);

        oscillator.frequency.setValueAtTime(freq, ctx.currentTime);
        oscillator.type = 'sine';

        const startTime = ctx.currentTime + i * 0.1;
        gainNode.gain.setValueAtTime(0, startTime);
        gainNode.gain.linearRampToValueAtTime(0.2, startTime + 0.05);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + 0.3);

        oscillator.start(startTime);
        oscillator.stop(startTime + 0.3);
      });
    } catch (e) {
      // Silently fail if audio not supported
    }
  };

  const playWrong = () => {
    try {
      const ctx = getAudioContext();
      resumeIfNeeded(ctx);
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);

      oscillator.frequency.setValueAtTime(220, ctx.currentTime);
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.08, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.1);

      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.1);
    } catch (e) {
      // Silently fail if audio not supported
    }
  };

  return { playCorrect, playStreak, playWrong };
};
